export const environment = {
  appName: 'FINEXWORD',
  appVersion: '1.1.6',
  production: true,
  serverUrl: 'https://voice.finexword.com',
  contentUrl: 'https://finexword.com/api'
}
